<nav class="bottom-nav">
  <div class="bottom-nav-inner">
    @for (item of navItems; track item.route) {
    <a class="bottom-nav-item" [routerLink]="item.route" routerLinkActive="active">
      <app-icon [name]="item.icon" size="lg" />
      <span>{{ item.label }}</span>
      @if (item.showBadge && vehicleService.watchlist().length > 0) {
      <span class="watchlist-badge">{{ vehicleService.watchlist().length }}</span>
      }
    </a>
    }
  </div>
</nav>